var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{attrs:{"type":"radialBar","width":"100%","options":_vm.chartOptions,"series":[_vm.completedProportion || 0]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }